import { CoreModal, CoreModalDescription } from "@verity/components/core";
import i18n from "../../../../i18n";
import { useCallback, useState } from "react";

type UnpublishModalProps = {
	onClose: () => void;
	onUnpublish: () => Promise<void>;
};

export default function UnpublishModal({ onClose, onUnpublish }: UnpublishModalProps) {
	const [isUnpublishing, setIsUnpublishing] = useState(false);

	const handleUnpublish = useCallback(async () => {
		setIsUnpublishing(true);
		await onUnpublish();
		setIsUnpublishing(false);
	}, [onUnpublish]);

	return (
		<CoreModal
			title={i18n.t("portal.components.assessmentPageTSX.columnList.unpublishModal.title")}
			open
			onClose={onClose}
			buttons={[
				{
					text: i18n.t("portal.components.assessmentPageTSX.columnList.unpublishModal.cancel"),
					color: "secondary",
					onClick: onClose,
				},
				{
					text: i18n.t("portal.components.assessmentPageTSX.columnList.unpublishModal.unpublish"),
					onClick: handleUnpublish,
					disabled: isUnpublishing,
					loading: isUnpublishing,
				},
			]}
		>
			<CoreModalDescription>
				{i18n.t("portal.components.assessmentPageTSX.columnList.unpublishModal.description")}
			</CoreModalDescription>
		</CoreModal>
	);
}
